import CollapsibleCardList, { CardData } from "../../../components/CollapsibleCardList";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getData } from "../../../actions/apiCall";
import React, { useEffect } from "react";
import PrimaryConfig from "../../../configs/users/primary.config";
import ContactConfig from "../../../configs/users/contact.config";
import { useEducationConfig } from "../../../configs/users/educations.config";
import { useExperianceConfig } from "../../../configs/users/experiance.config";
import AddressConfig from "../../../configs/users/address.config";


const ignoreIdFromObject = (obj: any) => {
    const newObj = { ...obj };
    delete newObj?._id;
    return newObj;
};

const ProfileDeails = () => {
    const { app: { user } } = useSelector((state: any) => ({
        app: state.app
    }));
    const [experiance, setExperiance] = React.useState<any>([]);
    const [educations, setEducations] = React.useState<any>([]);
    const dispatch = useDispatch();
    const EducationConfig = useEducationConfig();
    const ExperianceConfig = useExperianceConfig();

    useEffect(() => {
        if (user?._id) {
            getExperiance(user?._id);
            getEducations(user?._id);
        }
    }, [user?._id]);

    const getExperiance = async (id: string) => {
        try {
            const resData = await dispatch(getData(`/experiance/${id}`));
            if (resData) {
                setExperiance(resData.data?.experiance);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getEducations = async (id: string) => {
        try {
            const resData = await dispatch(getData(`/educations/${id}`));
            if (resData) {
                setEducations(resData.data?.education);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const data = [
        {
            header: "Primary Details",
            config: PrimaryConfig,
            id: user?._id,
            fields: [
                { label: "First Name", value: user?.firstName },
                { label: "Last Name", value: user?.lastName },
                { label: "Designation", value: user?.jobTitles?.name },
                { label: "Date of Birth", value: new Date(user?.dob).toDateString() },
                { label: "Marital Status", value: user?.maritalStatus ?? "-" },
                { label: "Blood Group", value: user?.bloodGroup ?? "-" },
                { label: "Gender", value: user?.gender },
                { label: "Physically Handicapped", value: user?.physicalChallenges ?? "-" },
            ],
        },
        {
            header: "Education Details",
            config: EducationConfig,
            id: user?._id,
            isMultiLevel: true,
            fields: educations?.map(ele => [
                { label: "Highest Qualification", value: ele?.degree },
                { label: "Specialization", value: ele?.specialization },
                { label: "Passing Year", value: new Date(ele?.endDate).toDateString() },
                { label: "University", value: ele?.University },
                { label: "Institute", value: ele?.institueName },
                { label: "Percentage", value: ele?.percentage },
                { label: "Grade", value: ele?.grade },
            ]),
        },
        {
            header: "Contact Details",
            config: ContactConfig,
            id: user?._id,
            fields: [
                { label: "Work Email", value: user?.workEmail },
                { label: "Personal Email", value: user?.email },
                { label: "Work Phone", value: user?.mobile },
                { label: "Residential Contact Number", value: user?.residentialContactNumber },
                { label: 'Emergency Contact Number', value: user?.emergencyContactNumber },
            ],
        },
        {
            header: "Work Experience",
            config: ExperianceConfig,
            id: user?._id,
            isMultiLevel: true,
            fields: experiance?.map(ele => [{ label: "Total Experience", value: ele?.totalExperience },
            { label: "Current Company", value: ele?.companyName },
            { label: "Designation", value: ele?.designation },
            { label: "Location", value: ele?.location },
            { label: "Joining Date", value: new Date(ele?.startDate).toDateString() },
            { label: "Leaving Date", value: new Date(ele?.endDate).toDateString() },
            { label: "Employee ID", value: ele?.employeeId }]),
        },
        {
            header: "Address Details",
            config: AddressConfig,
            id: user?._id,
            fields: [
                { label: "Permanent Address", value: Object.values(ignoreIdFromObject(user?.permanentAddress[0] ?? {}))?.join(", ") },
                { label: "Current Address", value: Object.values(ignoreIdFromObject(user?.presentAddress[0] ?? {}))?.join(", ") },
            ],
        },
    ] as CardData[];

    return (
        <CollapsibleCardList data={data} />
    );

}

export default ProfileDeails;